import caidData from "@/data/caid.json";
import returnQueryParams from "@/http/returnQueryParams";
import $store from '@/store';

const getRegion = () => {
  const configObject = getConfigurationObject();

  let region;
  if (configObject && configObject.region) {
    region = configObject.region;
  } else {
    region = getCaid() && getCaid().region.toLowerCase();
  }

  return region;
}

const getLocale = () => {
  const configObject = getConfigurationObject();

  let locale;
  if (configObject && configObject.locale) {
    locale = configObject.locale.toLowerCase();
  } else {
    locale = getCaid() && getCaid().locale.toLowerCase();
  }

  return locale;
}

const getDomain = () => {
  const configObject = getConfigurationObject();

  let domain;
  if (configObject && configObject.domain) {
    domain = configObject.domain.toLowerCase();
  } else {
    const regex = /\/[a-z]{2}[-_][a-z]{2}(\/|$)/i;
    domain = getCaid() && getCaid().domain.toLowerCase().replace(regex, '');
    if(domain?.includes("netlify")) domain="dev3.vans.com" // support preview links from netlify
  }

  return domain;
}

const getCaid = () => {
  const noEsiActive = () => {
    let isIframeSameOrigin;

    try {
      isIframeSameOrigin = window.parent.location.href !== window.location.href;
    } catch {
      isIframeSameOrigin = false;
    }

    return isIframeSameOrigin && (!!returnQueryParams()['canvas'] || !!returnQueryParams()['no-esi'] || window.location.href.includes('/2.0/customizer'))
  };

  // Check if caid already exist, checking by order of importance: $store, configurationObject.
  let customsCAID = $store && $store.state.utils.caid || null;
  const caidEnvironments = Object.keys(caidData);
  const caidEnv = ($store && caidEnvironments.includes($store.state.utils.env)) ? $store.state.utils.env : 'dev';
  !customsCAID && getConfigurationObject() ? customsCAID = getConfigurationObject().caid : null;

  if(customsCAID) return caidData[caidEnv].find(element => {
    return element.caid==customsCAID;
  });
  const customsDomain = getConfigurationObject() ? getConfigurationObject().domain : null;

  let url = noEsiActive() ? window.parent.location.href : (process.env.VUE_APP_DOMAIN || customsDomain || window.location.href);
  // support preview links from netlify
  url = document.referrer.includes("netlify") ? document.referrer : url;
  const caidJSON = [];
  Object.keys(caidData).forEach(caidenv => caidData[caidenv].filter((element) => {
     if( url.includes(element.domain) || url.includes(element.domain.replace('_', '-'))) caidJSON.push(element);
  }));

  if(returnQueryParams()['canvas']) {
    return caidJSON.find(el => el.caid.includes("canvas"))
  } else {
    return caidJSON.length === 1
      ? caidJSON[0]
      : caidJSON.find(element => {
        const customsFlag = 'customs-'; // Will filter when APAC domains is selected
        const locale1 = element.locale.replace('-', '_');
        const locale2 = element.locale.replace('_', '-');
        const ranking = element.ranking;

        const localeInUrl = (url.includes(locale1) || url.includes(locale2) || (url.includes(customsFlag) && element.domain.includes(customsFlag))) && ranking===1;
        console.log(localeInUrl);
        return localeInUrl || ranking===1;
      });
  }
};

const getConfigurationObject = () => {
  const configEl = document.getElementById('vfdp-vuecomponents-data');
  // checks if the configuration element exists
  if (configEl) {
    const configObjectStr = configEl.dataset.configObject;
    // checks if it contains the configuration data-attribute
    if (configObjectStr) {
      return JSON.parse(configObjectStr);
    }
  }
  return null;
}

export { getRegion, getLocale, getCaid, getDomain, getConfigurationObject };